import React, { useEffect, useMemo, useRef, useReducer, useState } from 'react';
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'; 
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { Tooltip } from '../../components/utils/Tooltip';
import { BotonNuevo } from '../../components/buttons/BotonNuevo';
import { BotonExportarExcel } from '../../components/buttons/BotonExportarExcel';
import { BotonGeneral } from '../../components/buttons/BotonGeneral';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { SearchTable } from '../../components/utils/SearchTable';
import { useMarcas } from '../../../hooks/registros/useMarcas';


export const Marcas = () => {
    const classNameInput = "containerScroll text-white h-[30px] rounded px-4 w-full bg-zinc-800 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"   
    const [isOpen, openModal, closeModal] = useModal()
    const idTablaMarcas = "tabla-marcas";
    
    const {marcas } = useMarcas();

    
    useEffect(() => {
        
    }, [])

    
    
    return (
        <>
            <ContenedorParametros
                titulo='Marcas' tablaId={idTablaMarcas}
            >   
                <BotonProcesar></BotonProcesar>       
                
                <BotonNuevo onClick={openModal}></BotonNuevo>
            </ContenedorParametros>
            
            <Tooltip id={'Estado'}>Estado</Tooltip>
            <Tooltip id={'Categoria'}>Categoria</Tooltip>

            <div className="containerScroll mt-7 relative top-0 bottom-0 left-0 right-0 contenedor-tabla">
                <table id={idTablaMarcas} className="tableResponsive">
                    <thead>
                        <tr>
                            <th className="w-[20px]">N°</th>
                            <th className="w-[150px]">COD</th>
                            <th className="w-[70%]">NOMBRE</th>
                            <th className="w-[300px]">USUARIO CREACION</th>
                            <th className="w-[300px]">FECHA CREACION</th>
                            <th className="w-[150px]"></th>
                        </tr>
                    </thead>
                    <tbody>
                    {   
                                marcas.length > 0 
                                ? marcas.map((marca, i) => {
                                    return (
                                        <tr key={marca.cod} className=''>
                                            <td data-label="" className='tablenum text-center w-[20px]'>{++i}</td>
                                            <td data-label="Nombre" className="text-center w-[150px]">{marca.codigoMarca}</td>
                                            <td data-label="Marca" className="text-center w-[70%]">{marca.nombreMarca}</td>
                                            <td data-label="Codigo" className="text-center w-[300px]">{marca.usuarioCrecion}</td>
                                            <td data-label="U. Medida" className="text-center w-[300px]">{marca.fechaCreacion}</td>
                                            <td data-label="Opciones" className="tableopciones text-center w-[10px]" >
                                                <button className="bg-blue-500 hover:bg-blue-600 text-[14px] px-[5px] py-1 rounded">
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                                <button  className="bg-red-500 hover:bg-red-800 text-[14px] px-[5px] py-1 rounded ml-3">
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                                : <tr><td colSpan="6" className="text-center">No hay información que mostrar con los parámetros seleccionados.</td></tr>
                            }
                                
                    </tbody> 
                </table>
            </div>
            <Modal 
                isOpen={isOpen} closeModal={closeModal} action={{}}
                title="Registrar Marca"
                spinner={{}}
            >
                <div className="flex  items-center flex-wrap justify-center">
                        <div className="w-[500px] px-4">
                            <div className="flex flex-col justify-between w-full form-content">                        
                                <div className='lg:flex-col lg:w-full'>
                                    <label>Nombre Comecial: </label>
                                    <div className="flex items-center gap-4 w-[250px]">
                                        <input autoFocus={true} className={`${classNameInput} caret-input`}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </Modal>
        </>
    )
}